import { render, staticRenderFns } from "./Beacon.vue?vue&type=template&id=0c3815e2&"
import script from "./Beacon.vue?vue&type=script&lang=js&"
export * from "./Beacon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports